// eslint-disable-next-line no-console
console.warn(
  "WARNING: @starbeam/core has been renamed to @starbeam/universal. Please update your imports to refer to @starbeam/universal.",
);
export * from "@starbeam/universal";
